var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9714 2.3999C6.67869 2.3999 2.40002 6.7999 2.40002 12.2433C2.40002 16.5945 5.14151 20.2777 8.94468 21.5813C9.42017 21.6793 9.59434 21.3695 9.59434 21.1089C9.59434 20.8807 9.57867 20.0985 9.57867 19.2835C6.91614 19.8703 6.36169 18.1101 6.36169 18.1101C5.9338 16.9693 5.29981 16.6761 5.29981 16.6761C4.42837 16.0731 5.36329 16.0731 5.36329 16.0731C6.32995 16.1383 6.83718 17.0835 6.83718 17.0835C7.69276 18.5827 9.07144 18.1591 9.62608 17.8983C9.70523 17.2627 9.95895 16.8227 10.2283 16.5783C8.10478 16.3501 5.87052 15.5027 5.87052 11.7217C5.87052 10.6461 6.2506 9.7661 6.85286 9.0817C6.75784 8.8373 6.42497 7.8267 6.94807 6.4741C6.94807 6.4741 7.75624 6.2133 9.57847 7.4845C10.3586 7.26904 11.1632 7.15943 11.9714 7.1585C12.7796 7.1585 13.6034 7.2727 14.3642 7.4845C16.1866 6.2133 16.9948 6.4741 16.9948 6.4741C17.5179 7.8267 17.1848 8.8373 17.0898 9.0817C17.7079 9.7661 18.0723 10.6461 18.0723 11.7217C18.0723 15.5027 15.8381 16.3337 13.6986 16.5783C14.0474 16.8879 14.3483 17.4745 14.3483 18.4035C14.3483 19.7235 14.3326 20.7829 14.3326 21.1087C14.3326 21.3695 14.507 21.6793 14.9823 21.5815C18.7855 20.2775 21.5269 16.5945 21.5269 12.2433C21.5426 6.7999 17.2483 2.3999 11.9714 2.3999Z",
    fill: "#47494D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(2.40002 2.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.d77b3093bad56c8b4c4dd1b903d07629.svg";
export { ForwardRef as ReactComponent };